import { getResumeByRfc, normalRenounce, renounceByDeath, getRenounce, 
          getRenounceRequests, acceptRenounceRequest, rejectRenounceRequest, 
          cancelRenounceRequest } from "@/api/saving";

export default class Saving {
  constructor() {

  }

  getResumeByRfc = (token_auth, rfc) => {
    return getResumeByRfc(token_auth, rfc).then(response => {
      return response;
    }).catch(error => {
      throw error;
    });
  }

  normalRenounce = ({token_auth, rfc, name, middle_name, paternal_name, maternal_name, email, cellphone, account_number, bank_name, withdraw_type}) =>{
    return normalRenounce({
      token_auth: token_auth, 
      rfc: rfc, 
      name: name, 
      middle_name: middle_name, 
      paternal_name: paternal_name, 
      maternal_name: maternal_name, 
      email: email, 
      cellphone: cellphone, 
      account_number: account_number, 
      bank_name: bank_name, 
      withdraw_type: withdraw_type
    }).then(response => {
      return response;
    }).catch(error => {
      throw error.response.data.response.message;
    });
  }

  renounceByDeath = ({token_auth, rfc, name, middle_name, paternal_name, maternal_name, email, cellphone, 
    account_number, bank_name, withdraw_type, beneficiary_name, beneficiary_middle_name, beneficiary_paternal_name, beneficiary_maternal_name}) =>{
    return renounceByDeath({
        token_auth: token_auth, 
        rfc: rfc, 
        name: name, 
        middle_name: middle_name, 
        paternal_name: paternal_name, 
        maternal_name: maternal_name, 
        email: email, 
        cellphone: cellphone, 
        account_number: account_number, 
        bank_name: bank_name, 
        withdraw_type: withdraw_type,
        beneficiary_name: beneficiary_name,
        beneficiary_middle_name: beneficiary_middle_name,
        beneficiary_paternal_name: beneficiary_paternal_name,
        beneficiary_maternal_name: beneficiary_maternal_name
      }).then(response => {
      return response;
    }).catch(error => {
      throw error.response.data.response.message;
    });
  }

  getRenounce = (token_auth, rfc) => {
    return getRenounce(token_auth, rfc).then(response => {
      return response;
    }).catch(error => {
      throw error;
    })
  }

  getRenounceRequests = (token_auth) => {
    return getRenounceRequests(token_auth).then(response => {
      return response;
    }).catch(error => {
      throw error;
    })
  }

  acceptRenounceRequest = (token_auth, id) => {
    return acceptRenounceRequest(token_auth, id).then(response => {
      return response;
    }).catch(error => {
      throw error;
    })
  }

  rejectRenounceRequest = (token_auth, id) => {
    return rejectRenounceRequest(token_auth, id).then(response => {
      return response;
    }).catch(error => {
      throw error;
    })
  }

  cancelRenounceRequest = (token_auth, id) => {
    return cancelRenounceRequest(token_auth, id).then(response => {
      return response;
    }).catch(error => {
      throw error;
    })
  }
}